export default __webpack_public_path__ + "static/media/conveni_K.3437f24e.jpg";